export const MEETING_SAVE_SUCCESSFUL = "meeting_save_successful";
export const MEETING_SAVE_FAILED = "meeting_save_failed";
export const WAITING_FOR_RESULT = "waiting_for_result";
export const SEND_STORY_EMAILS_SUCCESSFUL = "send_story_emails_successful";
export const SEND_STORY_EMAILS_FAILED = "send_story_emails_failed";